import { now } from './datetime';

export function setCookie(name: string, value: string) {
  document.requestStorageAccess().then(function () {
    const newDate = now();
    newDate.setDate(newDate.getDate() + 7);

    document.cookie = `${name}=${value}; expires=${newDate.toUTCString()}; secure=true; samesite=Strict`;
  });
}

/**
 * @reference - https://stackoverflow.com/a/15724300/2284240
 */
export function getCookie(name: string) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(';').shift();
}

/**
 * @reference - https://stackoverflow.com/a/23995984/2284240
 */
export function deleteCookie(name: string) {
  document.requestStorageAccess().then(function () {
    document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
  });
}
